export default __webpack_public_path__ + "static/media/coolnes.851877bb.png";